import React, { useContext, useMemo } from 'react'
import DataTable from '@3mcom/mds-library/dist/node/DataTable'
import ProductOptionCTA, { getFirstCTA } from './ProductOptionCTA'
import { Translations } from '../../services/TranslationService'
import { PDP_SELECTORS_ID } from '../../constants/PDPConstants'
import scrollService from '../../services/ScrollService'
import { trackPDPData } from '../../services/TealiumService'
import { StateContext } from '../../services/StateService'
import NameAndIDsCell from '../../components/NameAndIDsCell'

/**
 * Builds mobile row data for a single product.
 * @param {Object} product - A single product option
 * @param {Array} columnIdentifiers - Column label/identifier pairs
 * @returns {Array} - Row data for the mobile DataTable
 */
const buildMobileData = (product, columnIdentifiers) => {
    if (!product || !columnIdentifiers.length) return []

    return columnIdentifiers.map((col) => {
        const attribute = product?.classificationAttributes?.find(
            (attr) => attr.identifier === col.identifier
        )
        return {
            column1: col.label,
            column2: attribute?.values ? attribute.values[0] : ''
        }
    })
}

/**
 * Mobile view for Product Options (SKUs) list.
 * @param {Object} props
 * @param {Array} props.columnIdentifiers - Column label/identifier pairs
 * @param {Map} props.ctaStyleMap - Map of snaps2Id to CTA style type
 */
const ProductOptionsMobile = ({ columnIdentifiers, ctaStyleMap }) => {
    const translations = useContext(Translations)
    const { productOptions, matchingProductOptions } = useContext(StateContext)

    const mobileColumns = useMemo(
        () => [
            {
                id: 'column1',
                accessor: 'column1',
                Header: '',
                style: {
                    color: 'black'
                }
            },
            {
                id: 'column2',
                accessor: 'column2',
                Header: ''
            }
        ],
        []
    )

    if (!columnIdentifiers.length || !productOptions?.length) return null

    const handleChangeOptions = () => {
        scrollService.scrollToSection(PDP_SELECTORS_ID)
        trackPDPData(
            `PDP Buying Zone Product Options Link Click: ${translations.changeOptions}`,
            'Engagement Event'
        )
    }

    return (
        <div className="sps2-pdp_product-options--container">
            <h5 className="mds-font_header--5">{translations.allResults}</h5>
            <p className="mds-font_body sps2-pdp_product-options--container_counter">{`${productOptions.length} ${translations.of} ${matchingProductOptions} ${translations.products}`}</p>
            {productOptions.map((product, i) => (
                <div
                    className="sps2-pdp_product-options--container_option"
                    key={`${i}-${product.productDetails.stockNumber}`}
                >
                    <NameAndIDsCell value={product.productDetails} />
                    <DataTable.Table
                        columns={mobileColumns}
                        data={buildMobileData(product, columnIdentifiers)}
                        disableHeader={true}
                    />
                    <div
                        className="sps2-pdp_product-options--container_btn-container"
                        tabIndex={-1}
                    >
                        <ProductOptionCTA
                            value={product}
                            styleType={
                                ctaStyleMap.get(getFirstCTA(product)?.snaps2Id) ??
                                'primary'
                            }
                        />
                    </div>
                </div>
            ))}
            <button
                className="mds-link_primary sps2-pdp_no-style-btn sps2-pdp_product-options--container_change-options"
                onClick={handleChangeOptions}
            >
                {translations.changeOptions}
            </button>
        </div>
    )
}

export default ProductOptionsMobile
